import React from 'react';
import Icon from '../../../components/AppIcon';

const PrimarySymptomCard = ({ primaryConcern, primaryTrend }) => {
  const getSeverityColor = (severity) => {
    if (severity >= 8) return 'text-red-600';
    if (severity >= 5) return 'text-amber-600';
    return 'text-green-600';
  };

  const getSeverityLabel = (severity) => {
    if (severity >= 8) return 'Severe';
    if (severity >= 5) return 'Moderate';
    if (severity >= 3) return 'Mild';
    return 'Minimal';
  };

  const getTrendInfo = (direction) => {
    if (direction === 'increasing') return { icon: 'TrendingUp', color: 'text-red-500', bg: 'bg-red-50 border-red-200', label: 'Worsening' };
    if (direction === 'decreasing') return { icon: 'TrendingDown', color: 'text-green-500', bg: 'bg-green-50 border-green-200', label: 'Improving' };
    return { icon: 'Minus', color: 'text-amber-500', bg: 'bg-amber-50 border-amber-200', label: 'Stable' };
  };

  const formatLabel = (str) => str?.replace(/_/g, ' ')?.replace(/\b\w/g, c => c?.toUpperCase());

  if (!primaryConcern) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
        <p className="text-sm text-gray-500 italic">No primary symptom identified for this period.</p>
      </div>
    );
  }

  const trendInfo = getTrendInfo(primaryTrend?.direction || 'stable');

  return (
    <div className="bg-white border-2 border-red-200 rounded-xl p-5">
      <div className="flex items-start justify-between gap-3 mb-4">
        <div>
          <p className="text-xs text-gray-500 uppercase tracking-wide font-medium mb-1">Primary Symptom</p>
          <h3 className="text-xl font-bold text-gray-900">{formatLabel(primaryConcern?.name)}</h3>
          <p className="text-sm text-gray-600 mt-0.5">
            <Icon name="MapPin" size={12} className="inline mr-1 text-gray-400" />
            {formatLabel(primaryConcern?.location)}
          </p>
        </div>
        <div className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-sm font-semibold ${trendInfo?.bg}`}>
          <Icon name={trendInfo?.icon} size={14} className={trendInfo?.color} />
          <span className={trendInfo?.color}>{trendInfo?.label}</span>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div className="text-center bg-gray-50 rounded-lg p-3">
          <p className={`text-2xl font-bold ${getSeverityColor(primaryConcern?.avgSeverity)}`}>
            {primaryConcern?.avgSeverity}/10
          </p>
          <p className="text-xs text-gray-500 mt-0.5">Avg Severity</p>
          <p className={`text-xs font-medium mt-0.5 ${getSeverityColor(primaryConcern?.avgSeverity)}`}>
            {getSeverityLabel(primaryConcern?.avgSeverity)}
          </p>
        </div>
        <div className="text-center bg-gray-50 rounded-lg p-3">
          <p className="text-2xl font-bold text-gray-900">{primaryConcern?.frequency}×</p>
          <p className="text-xs text-gray-500 mt-0.5">Frequency</p>
          <p className="text-xs text-gray-400 mt-0.5">in period</p>
        </div>
        <div className="text-center bg-gray-50 rounded-lg p-3">
          <p className="text-sm font-bold text-gray-900 mt-2">
            {primaryConcern?.avgSeverity >= 8 ? 'High' : primaryConcern?.avgSeverity >= 5 ? 'Moderate' : 'Low'}
          </p>
          <p className="text-xs text-gray-500 mt-0.5">Impact Level</p>
        </div>
      </div>
    </div>
  );
};

export default PrimarySymptomCard;
